import { createContext } from "react";

const initialContext: {
  oois: Array<Travelguide.OOI>;
  rootNodeId?: string;
} = {
  oois: [],
};

export const CatalogContext = createContext(initialContext);
